import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { GungFlowService, CustomerProductPrice, PriceService, Product } from 'gung-standard';
import { first } from 'rxjs';

@Component({
    selector: 'cult-cult-product-export-card',
    templateUrl: './cult-product-export-card.component.html',
    styleUrls: ['./cult-product-export-card.component.scss'],
    standalone: false
})
export class CultProductExportCardComponent extends ListItemRendererComponent<Product[]> implements OnInit, OnChanges, AfterViewInit {  protected gungFlowService = inject(GungFlowService);
  protected priceService = inject(PriceService);

  productPriceMap: { [s: string]: CustomerProductPrice } = {};
  isReturnFlow: boolean = false;

  ngOnInit() {
    this.gungFlowService.getSelectedFlow().pipe(first()).subscribe(flow => {
      this.isReturnFlow = !!flow.isReturnOrder;
      if (!this.isReturnFlow) {
        this.getData();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.isReturnFlow) {
      this.getData();
    }
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  getData(): void {
    const cachedIds: string[] = Object.keys(this.productPriceMap);
    const toGetIds: string[] = this.data.map(p => p.id).filter(id => !cachedIds.includes(id));

    if (!toGetIds || toGetIds.length === 0) {
      return;
    }

    this.priceService.getCurrentCustomerPrices(toGetIds).pipe(first()).subscribe(prices => {
      for (const price of prices) {
        this.productPriceMap[price.productId] = price;
      }
    });
  }
}
